// Datos legales de Wovll. RELLENA con tus datos reales antes de vender.
export const legal = {
  brand: "Wovll",
  legalName: "[Tu nombre o razón social] — RELLENAR",
  nif: "[NIF/CIF] — RELLENAR",
  address: "[Dirección fiscal] — RELLENAR",
  email: "edusanchez98.98@gmail.com",
  domain: "wovll.beautyos.es",
  returnDays: 30,
};
